import { Component, OnInit, ViewChild } from "@angular/core";
import { ActionSheetController, IonContent,  IonSlides, NavController} from "@ionic/angular";
import { AbstractControl, FormControl, FormGroup, NgForm, Validators } from "@angular/forms";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { RestService } from "src/app/services/rest/rest.service";
import { UtilsService } from "src/app/services/utils/utils.service";
import { SessionService } from "src/app/services/session/session.service";
import { Product } from 'src/app/interfaces/product';
import { Albaran } from 'src/app/interfaces/albaran';
import { ActivatedRoute } from '@angular/router';
import { Client } from "src/app/interfaces/client";

@Component({
    selector: "app-crear-pedido",
    templateUrl: "./crear-pedido.page.html",
    styleUrls: ["./crear-pedido.page.scss"],
})

export class CrearPedidoPage implements OnInit {

    product: Product;
    albaran: Albaran;
    client: Client;
    clienteUrl: string;
    productsClient: any;
    isEdit = false;
    totalField: number;
    totalWithIva = 0;
    userCargas: any;
    userAlbs: any;
    tarifasClient: any;
    products: Product[];
    lineSelected: any;
    clientField: string;
    repartidorField: string;
    comentarioField: string;
    delivered = false;
    showed = false;
    dateField: string;
    timeField: string;
    photo:string = "/assets/images/logo.png";

    @ViewChild(IonContent, { static: true }) ionContent: IonContent;
    @ViewChild(IonSlides, { static: false }) ionSlides: IonSlides;
    @ViewChild("productoFormRef", { static: false }) productoFormRef: NgForm;
    @ViewChild("direccionFormRef", { static: false }) direccionFormRef: NgForm;
    @ViewChild("paymentFormRef", { static: false }) paymentFormRef: NgForm;

    public order: any = {
        id: 1,
        product: "",
        quantity: 0,
        address: "",
        hour: "",
        phone: "",
        message: "",
        items: [
            {
                id: 1,
                name: "Denim T-Shirt",
                amount: 15.0,
            },
            {
                id: 1,
                name: "Denim Pants",
                amount: 5.0,
            },
            {
                id: 1,
                name: "Black T-Shirt",
                amount: 5.0,
            },
        ],
        subtotal: 25.0,
        shippingFee: 5.0,
        total: 30.0 ,
    };

    public productoForm: FormGroup;
    public paymentForm: FormGroup;
    public direccionForm: FormGroup;
    public imagePath: SafeResourceUrl;
    public times = [];
    public slidesOpts = {
        allowTouchMove: false,
        autoHeight: true,
    };

    public slides: string[];
    public currentSlide: string;
    public isBeginning: boolean = true;
    public isEnd: boolean = false;

    get billingProduct(): AbstractControl {
        return this.productoForm.get("product");
    }

    get billingQuantity(): AbstractControl {
        return this.productoForm.get("quantity");
    }

    get billingFirstName(): AbstractControl {
        return this.productoForm.get("first_name");
    }

    get billingLastName(): AbstractControl {
        return this.productoForm.get("last_name");
    }

    get billingEmail(): AbstractControl {
        return this.productoForm.get("email");
    }

    get billingAddress(): AbstractControl {
        return this.productoForm.get("address");
    }

    get billingCity(): AbstractControl {
        return this.productoForm.get("city");
    }

    get billingState(): AbstractControl {
        return this.productoForm.get("state");
    }

    get billingZip(): AbstractControl {
        return this.productoForm.get("zip");
    }

    get billingCountryCode(): AbstractControl {
        return this.productoForm.get("country_code");
    }

    get shippingAddress(): AbstractControl {
        return this.direccionForm.get("address");
    }

    get shippingPhone(): AbstractControl {
        return this.direccionForm.get("phone");
    }

    get shippingDeliveryTime(): AbstractControl {
        return this.direccionForm.get("delivery_time");
    }

    get paymentNumber(): AbstractControl {
        return this.paymentForm.get("number");
    }

    get paymentExpiration(): AbstractControl {
        return this.paymentForm.get("expiration");
    }

    get paymentCvv(): AbstractControl {
        return this.paymentForm.get("cvv");
    }

    constructor(
        private actionSheetCtrl: ActionSheetController,
        private navCtrl: NavController,
        private sanitizer: DomSanitizer,
        private route: ActivatedRoute,
        private rest: RestService,
        private session: SessionService,
        private utils: UtilsService
    ) { }

    async ngOnInit() {
        this.setupForm();
        this.buildSlides();
        this.times = [
            "09:00",
            "10:00",
            "11:00",
            "12:00",
            "13:00",
            "14:00",
            "15:00",
        ];
        this.route.queryParams
            .subscribe(params => {
                this.clienteUrl = params.cliente;
                //this.getClient(this.clienteUrl);
                console.log(this.clienteUrl); // price
            }
        );
        this.getProducts();
        this.loading();
        if(this.clienteUrl != undefined) this.getClient(this.clienteUrl);
        this.productsClient = this.products;
    }

    changeTotal() {        
        this.totalField = 0;
        if (this.productsClient) {
            this.productsClient.forEach((elem) => {
                this.totalField += elem.unit * elem.price || 0;
            });
        }
        (this.totalField as any) = this.utils.parseDecimals(this.totalField);
        this.totalPriceWithIva();
    }

    totalPriceWithIva() {
        this.totalWithIva = 0;
        for (const line of this.productsClient) {
            let result = this.calcTotalWithIva(line);
            result = result.toString();
            this.totalWithIva = this.totalWithIva + parseFloat(result);
        }
    }

    parseDecimals(num: number) {
        return this.utils.parseDecimals(num);
    }

    showProducts() {
        this.showed = !this.showed;

    }

    calcTotalWithIva(line: any) {
        if(line.iva != undefined){
            const multi = 1 + line.iva / 100;
            return this.parseDecimals(line.price * line.unit * multi);
        } else return 0;        
    }

    totalProductos(prod) {
        return (((this.userCargas && this.userCargas[prod.product]) ? this.userCargas[prod.product] : 0) -
            ((this.userAlbs && this.userAlbs[prod.product]) ? this.userAlbs[prod.product] : 0))
    }

    async getClient(clientId: string) {
        await this.utils.showLoading();
        const result: any = await this.rest.getClient(clientId);
        this.client = result.body;        
        this.direccionForm = new FormGroup({
            address: new FormControl(this.client.dfiscal, Validators.required),
            phone: new FormControl("+34665885666", Validators.required),
            delivery_time: new FormControl(null, Validators.required),
            message: new FormControl(""),
        });
    }

    async loading(){
        try {
            await this.utils.showLoading();
            this.tarifasClient = await this.getDefaultTarifas();        
            // We store both the name and id of the products
            this.productsClient = this.products;        
            this.productsClient.forEach(
                product => {
                    const auxId = product._id;
                    delete product._id;
                    //product.product = auxId;
                    let p = this.tarifasClient.filter(e => e.product === product.name);
                    if (!p || p.length === 0) {
                        p = this.tarifasClient[product.name];
                        if (this.isEdit) {
                            this.lineSelected.cantidad.forEach(elem => {
                                if (elem.product === product.product) {
                                    product.price = p.price ? p.price : elem.price;
                                    product.priceShow = (p.price ? p.price : elem.price) + ('(' + elem.price + ')').toString();
                                }
                            });
                        } else {
                            if(product.price) product.price = p.price;
                        }
                        if(product.iva) product.iva = p.iva;
                        if(product.ivaRequered) product.ivaRequered = p.ivaRequered;
                        if(product.unit) product.unit = '';
                    }
                    if (p && p.length > 0) {
                        if (this.isEdit) {
                            this.lineSelected.cantidad.forEach(elem => {
                                if (elem.product === product.product) {
                                product.price = p[0].price ? p[0].price : elem.price;
                                product.priceShow = (p[0].price ? p[0].price : elem.price) + ('(' + elem.price + ')').toString();
                                }
                            });
                        } else {
                            product.price = p[0].price;
                        }
                        product.iva = p[0].iva;
                        product.ivaRequered = p[0].ivaRequered;
                        product.unit = '';
                    }
                }
            );            
            await this.utils.hideLoading();
        } catch (error) {
            console.log(error);
            await this.utils.hideLoading();
        }
    }

    async getProducts() {
        const resp: any = await this.rest.getProducts(1, 1000);
        if (resp.body && resp.body.records) {
            this.products = resp.body.records;
            //console.log(this.products);
        }
    }

    async getDefaultTarifas() {
        let res = [];
        const resp: any = await this.rest.getDefaultTarifas();
        if (resp) {
            res = resp.body.records;
            console.log(resp.body);
        }
        return res;
    }

    ionViewDidEnter() {
        this.ionSlides.updateAutoHeight();
    }

    buildSlides() {
        const slides = ["Producto", "Finalizar"];
        this.currentSlide = slides[0];
        this.slides = slides;
    }

    setupForm() {

        this.productoForm = new FormGroup({
            product: new FormControl("CUBITO VOGT", Validators.required),
            quantity: new FormControl("Hielos", Validators.required),            
            first_name: new FormControl("Test", Validators.required),
            last_name: new FormControl("Hielos", Validators.required),
            email: new FormControl("test@cumbreno.com", Validators.required),
            address: new FormControl("Calle Principal 4", Validators.required),
            city: new FormControl("Madrid", Validators.required),
            state: new FormControl("Madrid", Validators.required),
            zip: new FormControl("28006", Validators.required),
            country_code: new FormControl("ES", Validators.required),
        });

        this.direccionForm = new FormGroup({
            address: new FormControl("Calle Principal 4", Validators.required),
            phone: new FormControl("+34665885666", Validators.required),
            delivery_time: new FormControl(null, Validators.required),
            message: new FormControl(""),
        });

        this.paymentForm = new FormGroup({
            number: new FormControl("", Validators.required),
            expiration: new FormControl("", Validators.required),
            cvv: new FormControl("", Validators.required),
        });
    }

    async onSlidesChanged() {
        const index = await this.ionSlides.getActiveIndex();
        this.currentSlide = this.slides[index];
        this.isBeginning = await this.ionSlides.isBeginning();
        this.isEnd = await this.ionSlides.isEnd();
    }

    onSlidesDidChange() {
        this.ionContent.scrollToTop();
    }

    onBackButtonTouched() {
        this.ionSlides.slidePrev();
        this.ionContent.scrollToTop();
    }

    onNextButtonTouched() {
        if (this.currentSlide === "Producto") {
            this.productoFormRef = new NgForm([], []);
            this.productoFormRef.onSubmit(undefined);
            if (this.productsClient.length > 0) {
                this.productsClient.forEach(
                    (c) => {
                        if (c.unit) {
                            this.order.product += " - " + c.name;
                            this.order.quantity += c.unit;
                        }
                    }
                );
            }
            if (this.productoForm.valid) {
                this.ionSlides.slideNext();
                this.ionContent.scrollToTop();
            }
        } else if (this.currentSlide === "Finalizar") {
            this.paymentFormRef.onSubmit(undefined);
            if(this.client == null){
                if (this.paymentForm.valid) {      
                    this.saveItem();
                    this.navCtrl.navigateRoot("/finalizar-pedido", {
                        animated: true,
                        animationDirection: "forward",
                    });
                }
            } else {
                this.saveItem();
                this.navCtrl.navigateRoot("/finalizar-pedido", {
                    animated: true,
                    animationDirection: "forward",
                });                
            }            
        } else {
            this.ionSlides.slideNext();
            this.ionContent.scrollToTop();
        }
    }

    async saveItem() {

        let invalid = false;
        const fecha: any = new Date(this.dateField + ' ' + this.timeField);

        // fecha = fecha.getTime() + 7200000;
        const newFecha = new Date();
        newFecha.setTime(fecha);
        /* const sendAlbaran: Albaran = {
            cliente: this.clientField,
            fecha: newFecha, // To avoid timezone offset
            total: this.totalField,
            empleado: this.repartidorField,
            comment: this.comentarioField,
            regalos: [],
            delivered: this.delivered
        }; */

        this.repartidorField = '5f0c2b821d2f0703ebf97e46';
        this.comentarioField = "TEST";
        const sendAlbaran: Albaran = {
            cliente: this.clienteUrl,
            fecha: new Date(), // To avoid timezone offset
            total: this.order?.total,
            empleado: this.repartidorField,
            comment: this.comentarioField,
            regalos: [],
            delivered: this.delivered
        };

        sendAlbaran.cantidad = [...this.productsClient];
        if (sendAlbaran.cantidad.length > 0) {
            sendAlbaran.cantidad.forEach(
                (c) => {
                    if (!c.unit) {
                        c.unit = 0;
                    }
                }
            );
        }
        
        if (this.repartidorField !== '5f0c2b821d2f0703ebf97e46') {
            sendAlbaran.cantidad.forEach(
                prod => {
                    const p: any = this.userCargas[prod.product];
                    console.log(this.userCargas[prod.product]);
                    console.log(prod.unit);
                    if (!p) {
                        this.userCargas[prod.product] = 0;
                    }
                    if (!this.userAlbs) {
                        this.userAlbs = {};
                    }
                    if ((((this.userCargas[prod.product] || 0) - (this.userAlbs[prod.product] || 0)) < prod.unit)
                        && (prod.product !== '5ef5e43bdd4795f0c32a1530' && prod.product !== '5ef5e43bdd4795f0c32a152f')) {
                        this.utils.showToast('El número de unidades es mayor al que dispone el repartidor', 'danger', 3000);
                        invalid = true;
                    }
                }
            );
        }

        //sendAlbaran.regalos = await this.fillPromocion(sendAlbaran);
        if (!invalid) {

            await this.utils.showLoading();
            sendAlbaran.delivered = !this.delivered;
            console.log(sendAlbaran);

            let iva: any;
            let ivaCount = 0;
            this.productsClient.forEach(element => {
                iva = ((element.price * element.unit) * ((100 + element.iva) / 100));
                ivaCount = ivaCount + iva;
            })
            
            sendAlbaran.totalWithIva = ivaCount;
            const result = await this.rest.createAlbaran(sendAlbaran);
            console.log(result);
            
            if (result) {
                // this.lines.unshift(sendAlbaran);
                //this.clearData();
                if (sendAlbaran.delivered) {
                    await this.rest.createNotifications([sendAlbaran.empleado], 'albaran');
                }
                //await this.getAlbaranes();
                //await this.getAlbaranesCurrentSessionGrouped();
                //this.selectedView = 'main';
            }
            await this.utils.hideLoading();
        }
    }

    convertBlobToBase64 = (blob: Blob) =>
        new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onerror = reject;
            reader.onload = () => resolve(reader.result);
            reader.readAsDataURL(blob);
        });

    originalOrder = (): number => {
        return 0;
    };
}
